import { Button, type ButtonProps } from "@mantine/core"
import { useQueryState } from "@/hooks"

export function ToggleFilter({ name, children, ...props }: ButtonProps & { name: string }) {
  const [value, setValue] = useQueryState<string>(name)
  return (
    <Button
      size="compact-xs"
      color={value ? "blue" : "gray"}
      onClick={() => setValue(value ? undefined : "1")}
      {...props}
    >
      {children}
    </Button>
  )
}
